import IconSVG from "../../styles/svg-icons";
import { FeatureButton } from "../access/FeatureButton";
import { Preloader } from "./Preloader";

interface Props {
    isExportLoad: boolean;
    onExport: () => void;
    disabled?: boolean;
}

export default function ExportButton({
    isExportLoad,
    onExport,
    disabled = false,
}: Props) {
    return (
        <Preloader
            small
            fullScreen={false}
            inProgress={isExportLoad}
            text="Exporting..."
        >
            <FeatureButton
                disabled={disabled}
                onClick={onExport}
                className="btn-link"
            >
                <IconSVG name="export" width="16" height="16" />
                Export
            </FeatureButton>
        </Preloader>
    );
}

